import React, { useContext } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { BsDownload, BsFileXFill, BsFillAlarmFill, BsFillEyeFill, BsFillPersonFill } from "react-icons/bs";
import { toast } from "react-toastify";
import Id from "../../../../components/Formatters/Id";
import ButtonImage from "../../../../components/UI/Button/ButtonImage";
import ButtonImagePermission from "../../../../components/UI/Button/ButtonImagePermission";
import { AuthContext, funcionalidades } from "../../../../context/AuthContext";
import useDocumentoOs from "./useDocumentoOs";

const descricaoCell = (description) => (
  <OverlayTrigger placement="top" overlay={<Tooltip>{description}</Tooltip>} data-tag="allowRowEvents">
    <Button
      style={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        color: "#858796",
        textDecoration: "none",
        padding: 0,
      }}
      variant="link"
      data-tag="allowRowEvents"
    >
      {description}
    </Button>
  </OverlayTrigger>
);

const descricaoCellLeft = (description) => (
  <OverlayTrigger placement="top" overlay={<Tooltip>{description}</Tooltip>} data-tag="allowRowEvents">
    <Button
      style={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        color: "#858796",
        textDecoration: "none",
        padding: 0,
        textAlign: "left",
      }}
      variant="link"
      data-tag="allowRowEvents"
    >
      {description}
    </Button>
  </OverlayTrigger>
);

const useColumns = ({
  setShowAtribuirProcessoConfirm,
  setShowProrrogarOsConfirm,
  setShowCienciaConfirm,
  verificaOs,
  setShowAlertaNaoCiencia,
  responsabilidadeOrgao,
}) => {
  const { user } = useContext(AuthContext);

  const { buscaDocumento } = useDocumentoOs();

  const columns = [
    {
      name: "Tipo de Ação",
      selector: "descTipoAcaoFiscal",
      center: true,
      sortable: true,
      cell: (row) => descricaoCell(row.descTipoAcaoFiscal),
      minwidth: "10%",
    },
    {
      name: "Nº OS",
      selector: "codigo",
      center: true,
      sortable: true,
      minwidth: "5%",
    },
    {
      name: "IE/CNPJ/CPF",
      selector: "nuInscEstadual",
      cell: (row) => <Id value={row.nuInscEstadual ?? row.nuCnpj ?? row.nuCpf} />,
      center: true,
      minwidth: "5%",
    },
    {
      name: "Razão Social",
      selector: "contribuinte",
      center: false,
      sortable: true,
      cell: (row) => descricaoCellLeft(row.contribuinte),
      minwidth: "30%",
    },
    {
      name: "URT Contribuinte",
      selector: "urtContribuinte",
      center: true,
      sortable: true,
      cell: (row) => row.urtContribuinte,
      minwidth: "5%",
    },
    {
      name: "Última Atividade Realizada",
      selector: "ultimaAtividade",
      center: true,
      sortable: true,
      cell: (row) => descricaoCell(row.ultimaAtividade),
      minwidth: "20%",
    },
    {
      name: "Ações",
      selector: "",
      minwidth: "20%",
      center: true,
      cell: (row) => (
        <>
          <ButtonImagePermission
            permission={funcionalidades.os.atribuirOs}
            variant="bg-transparent"
            className="btn-lg pa-0 p-0"
            buttonImage={<BsFillPersonFill size="15" />}
            tooltipImage="Atribuir OS a um novo Diretor"
            onClick={() => {
              setShowAtribuirProcessoConfirm({
                show: true,
                body: `OS de Nº ${row.nuOs} sob responsabilidade de: `,
                context: row,
              });
            }}
          />
          {!row.dataCiencia && (
            <ButtonImagePermission
              permission={funcionalidades.ordemservico.tomarCiencia}
              variant="bg-transparent"
              className="btn-lg pa-0 p-0 mx-1"
              buttonImage={<BsFillEyeFill size="15" />}
              tooltipImage="Tomar ciência da OS"
              onClick={() => {
                setShowCienciaConfirm({
                  show: true,
                  body: `Confirma ciência da OS Nº ${row.codigo}?`,
                  context: row,
                });
              }}
            />
          )}

          {row.sqPedidoProrrogacao > 0 && row.stProrrogacao === "H" ? (
            <ButtonImagePermission
              permission={funcionalidades.os.prorrogarOs}
              variant="bg-link"
              className="btn-lg pa-0 p-0 mx-1"
              buttonImage={<BsFillAlarmFill size="15" />}
              tooltipImage="Prorrogar OS"
              onClick={
                user.codigo === row.diretorAtribuido
                  ? () => {
                      setShowProrrogarOsConfirm({
                        show: true,
                        context: row,
                      });
                    }
                  : () => {
                      toast.error(
                        "[doIncluirAndamento] Solicitação não realizada, pois o usuário não é o responsável por fazer essa atividade.",
                      );
                    }
              }
            />
          ) : null}
          <ButtonImagePermission
            permission={funcionalidades.os.cancelarOs}
            variant="btn-link"
            className="btn-lg pa-0 p-0 mx-1"
            buttonImage={<BsFileXFill size="15" style={{ color: "#C22125" }} />}
            tooltipImage="Cancelar OS"
            onClick={() => {
              verificaOs(row.codigo);
            }}
          />

          {responsabilidadeOrgao !== "F" && (
            <ButtonImage
              variant="btn-link"
              className="btn-lg pa-0 p-0 mx-1"
              buttonImage={<BsDownload size="15" style={{ color: "#E65729" }} />}
              tooltipImage={`Visualizar OS Nº ${row.codigo}`}
              onClick={() => {
                buscaDocumento(row.codigo);
              }}
            />
          )}
          {responsabilidadeOrgao === "F" &&
            (!row.dataCiencia ? (
              <ButtonImage
                className="btn-lg btn-link pa-0 p-0 mx-1"
                buttonImage={<BsDownload size="15" />}
                tooltipImage="Necessário dar ciência para visualizar documento da OS"
                onClick={() => {
                  setShowAlertaNaoCiencia(true);
                }}
                disabled
              />
            ) : (
              <ButtonImage
                variant="btn-link"
                className="btn-lg pa-0 p-0 mx-1"
                buttonImage={<BsDownload size="15" style={{ color: "#E65729" }} />}
                tooltipImage={`Visualizar OS Nº ${row.codigo}`}
                onClick={() => {
                  buscaDocumento(row.codigo);
                }}
              />
            ))}
        </>
      ),
    },
  ];

  return columns;
};

export default useColumns;
